import { Component, Inject, ElementRef, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { error } from '@angular/compiler/src/util';
import { formatDate, getLocaleDateTimeFormat, Location } from '@angular/common';
import {  ViewChild, TemplateRef } from '@angular/core';
import { NgbModal, NgbModalRef, NgbActiveModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { NgModel } from '@angular/forms';
import { ContentRef } from '@ng-bootstrap/ng-bootstrap/util/popup';
import { Observable } from 'rxjs';




declare let ClientIP: any;

@Component({
    selector: 'app',
    template: require('./app.component.html'),
    styles: [require('./app.component.css')]
})
export class AppComponent {
    @ViewChild("content") contentRef: any;
    @Input() name: any;
    location: AssiLocation;
    report: CollisionReport;
    navigation: Navigation[] = [];
    ipAddress: string;
    publicIP: any;

    screenHeight: any;
    screenWidth: any;
    //Footer variables
    clientHeight: number;

    CollisionReportId: number; // Replace this.report.CollisionReportId since this value gets lost some where
    CollisionReportUniqueId: string;
    ReferenceID: string;
    isLastPage: boolean; // On the last page, hide button "Clear"
    
    constructor(private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string, private router: Router, public translate: TranslateService,
        private spinnerService: Ng4LoadingSpinnerService, public elementRef: ElementRef, private modalService: NgbModal) {
        this.translate.setDefaultLang('en');
        var native = this.elementRef.nativeElement;
        var ip = native.getAttribute("ip");
        this.ipAddress = ip;
        this.location = <AssiLocation>{};
        this.report = <CollisionReport>{};
        this.navigation = <Navigation[]>{};
        this.CollisionReportId = 0;
        this.CollisionReportUniqueId = "";
        this.ReferenceID = "";
        this.isLastPage = false;

        this.clientHeight = window.innerHeight;

        this.initialize();

        this.getScreenSize();
    }
    
    getScreenSize() {
        this.screenHeight = window.innerHeight;
        this.screenWidth = window.innerWidth;
    }
    onResize(event: any) {
        this.screenHeight = window.innerHeight;
        this.screenWidth = window.innerWidth;
    }
    opencroms(): void {
        //const timer: ReturnType<typeof setTimeout> = setTimeout(() => '', 1000);

        //Production
        var url = "http://on.acc.int/croms/"

        //TEST
        //var url = "http://insurerresponse.accsupport.com/croms/"

        var wind = window
        wind.name = "test"
        wind.open(url, "Mywind", "width=800, height=800")
        wind.focus()
       // wind.close();
        //setTimeout(() => {
        //    alert("Logging out");
        //    wind.close();
        //}, 4000);
        location.reload();
        //wind.addEventListener("click" );
        
    }


    openLg(content: any, message: string) {
        const modal = this.modalService.open(content, { size: 'lg' });
       //modal.injector.name = message;
        //modal.name = message;
        
    }

    public onModalClose(): void {
        location.reload();
    }

    public initialize(): void {
       
        this.report.PageNavigation = [];
        var nav = <Navigation>{};
        nav.Index = 1;
        nav.IsCurrentPage = true;
        nav.PageName = "TEST Page";
        nav.IsValid = true;
        // this.report.PageNavigation[0] = nav;
        // this.initReport(this.report);
        this.navigation = this.report.PageNavigation;
        this.BindDriverPages();
        this.populateLocation();
    }
    useLanguage(language: string) {
        this.translate.use(language);
    }
    populateLocation(): void {
        //TODO Make Dynamic
        //this.ipAddress = "10.50.0.111";
        var any = location.host;
        if (this.ipAddress != null && this.ipAddress.match("10.50.")) {
            this.location.LocationId = 1;
            //Changed the name until we get the Location resolved.
            this.location.LocationName = "Toronto";
        }
        else if (this.ipAddress != null && this.ipAddress.match("10.51.")) {
            this.location.LocationId = 1;
            this.location.LocationName = "Toronto";
        }
        else {
            this.location.LocationId = 1;
            this.location.LocationName = "Toronto";
        }
        

    }
    public getLocation(): AssiLocation {
        return this.location;
    }
    public getBaseUrl(): string {
        return this.baseUrl;
    }

    public getNavigations(): Navigation[] {
        return this.report.PageNavigation;
    }

    public getReport(): CollisionReport {
        return this.report;
    }


    //Added to send log reports to any interface


    public logKioskReport(collisionReport: CollisionReport) {
        var count = this.navigation.toString();
        //this.report.PageNavigation;
        //var page = collisionReport.PageNavigation[].PageName;
        var timestamp = Date();

       // alert(page);

       // alert(timestamp);

     //   alert(count);

       // var requestFileSystem = window.requestFileSystem || window.webkitRequestFileSystem;

        // Check for the various File API support.
        

    }

    

    public setReport(collisionReport: CollisionReport): void {
        if ((collisionReport.FiveDigitCode != null && collisionReport.FiveDigitCode > 0)) {
            this.report = collisionReport;
            this.reportSubmit();
           // this.logKioskReport(collisionReport);
        }
        else {
            //alert('error');
        }
    }

    public setDataReport(collisionReport: CollisionReport): boolean {
        if ((this.report.FiveDigitCode != null && this.report.FiveDigitCode > 0)) {
            //Re-bind Report ID
            var id = this.report.CollisionReportId;
            this.report = collisionReport;
            this.report.CollisionReportId = id;
            this.reportDataSubmit();
            return true;
        }
        else
            alert('Error');
        return false;
    }

    public retriveReport(code: number, lang: string): void {
        if ((code != null && code > 0)) {
            this.querySubmit(code, lang);
            
        }
    }
    public initReport(collisionReport: CollisionReport): boolean {
        if ((collisionReport == null || collisionReport.CollisionReportUniqueId == null || collisionReport.CollisionReportUniqueId == ""))
        {
            this.reportGet();
            return true;
        }
        else {
            this.report = collisionReport;
            return true;
        }
    }
    private BindNavigation() {
        if (this.report != null && this.report.PageNavigation != null) {
            this.report.PageNavigation.splice(0);
            if (this.report.FiveDigitCode != null && this.report.FiveDigitCode > 0 && this.report.CollisionReportId > 0) {
                //if (this.report.CollisionReportId > 0) {
                if (this.report.EntityType == null || this.report.EntityType == "DRIVER") {
                    this.BindDriverPages();
                }
                else {
                    this.BindPedCyclistPages();
                }
            }
        }
        
    }

    onPageSelect(nav: Navigation) {
      
       //////  //alert(nav.IsValid);
        //if (nav.IsValid) {
            this.report.CurrentPage = nav.PageName;
            this.BindNavigation();
            this.router.navigate([nav.PageName]);
        //}
        //else {
        //    var content = "Please complete the current page and hit next"
        //    alert(content);
        //}
    }

    public reportGet(): void {
        this.spinnerService.show();
        var url = this.baseUrl + "api/report";
        this.http
            .get(url)
            .subscribe(res => {
                var v = res as CollisionReport;
                this.report = v;
                this.CollisionReportId = v.CollisionReportId;
                this.report.CollisionReportId = v.CollisionReportId;
                this.CollisionReportUniqueId = v.CollisionReportUniqueId;
                this.report.CollisionReportUniqueId = v.CollisionReportUniqueId;
                this.report.ReferenceID = v.ReferenceID;
                this.BindNavigation();
            }, error => console.log(error), () => this.spinnerService.hide());

    }

    public reportGetSync(): void {
        this.spinnerService.show();
        var url = this.baseUrl + "api/report";
        this.http
            .get(url)
            .toPromise().then(result => {
                var v = result as CollisionReport;
                this.report = v;
            });

        //(res => {
        //        var v = res as CollisionReport;
        //        this.report = v;
        //        this.CollisionReportId = v.CollisionReportId;
        //        this.report.CollisionReportId = v.CollisionReportId;
        //        this.CollisionReportUniqueId = v.CollisionReportUniqueId;
        //        this.report.CollisionReportUniqueId = v.CollisionReportUniqueId;
        //        this.BindNavigation();
        //    }, error => console.log(error), () => this.spinnerService.hide());
    }
   

    private reportInit(): void {
        this.spinnerService.show();
        var url = this.baseUrl + "api/report";
        this.http
            .put(url, this.report)
            .subscribe(res => {
                var v = res as CollisionReport;
                this.report = v;
                this.CollisionReportId = v.CollisionReportId;
                this.report.CollisionReportId = v.CollisionReportId;
                this.BindNavigation();
            }, error => console.log(error), () => this.spinnerService.hide());

    }
    private reportSubmit(): void {
        this.spinnerService.show();
        var url = this.baseUrl + "api/report";
        this.http
            .post(url, this.report)
            .subscribe(res => {
                var v = res as CollisionReport;
                this.report = v;
                if (this.report.IsFinalized) {

                    this.ReferenceID = v.ReferenceID;

                    if (this.report != null && this.report.ReportSubmissionStatus != null && this.report.ReportSubmissionStatus.StatusMessage != null) {
                        //var message = this.report.ReportSubmissionStatus.StatusMessage
                    }
                    
                    //Opens Modal to open CROMS
                    //this.openLg(this.contentRef, message)
                    //Opens CROMS
                   // this.opencroms();
                    if (this.report != null && this.report.ReportSubmissionStatus != null && this.report.ReportSubmissionStatus.StatusCode == 0) {
                        this.report = <CollisionReport>{};
                        this.initialize();
                        //location.reload();
                    }
                }
                else {
                  //  alert('error')
                    this.BindNavigation();
                }
            }, error => console.log(error), () => this.spinnerService.hide());
        //alert('error ' + error);

        

    }
    private reportDataSubmit():void {
        this.spinnerService.show();
        var url = this.baseUrl + "api/report";
        this.http
            .post(url, this.report)
            .subscribe(res => {
                var v = res as CollisionReport;
                this.report = v;
                if (this.report.IsFinalized) {
                    alert('Collision report submitted into CROMS.');
                    
                }
                else {
                    alert('Collision report submition failed');
                    this.BindNavigation();
                }
            }, error => console.log(error), () => this.spinnerService.hide());

    }

    private finalize(): void {
        if (this.report.IsFinalized) {
            var url = this.baseUrl + "api/report/SubmitCollisionReport";
            this.spinnerService.show();
            this.http
                .post(url, this.report)
                .subscribe(res => {
                    var v = res as SubmissionStatus;
                    alert(v.StatusCode);
                }, error => console.log(error), () => this.spinnerService.hide());
        }
    }
    private querySubmit(code: number, lang: string): void {
        this.spinnerService.show();
        var url = this.baseUrl + "api/report";
        this.http
            .get(url)
            .subscribe(res => {
                var v = res as CollisionReport;
                this.report = v;
                this.navigation = <Navigation[]>{};
                this.report.PageNavigation = [];
                var nav = <Navigation>{};
                nav.Index = 1;
                nav.IsCurrentPage = true;
                nav.PageName = "TEST Page";
                nav.IsValid = true;
                //  this.report.PageNavigation[0] = nav;
                this.navigation = this.report.PageNavigation;
                this.report.Language = lang;
                this.BindNavigation();
             //;
            }, error => console.log(error), () => this.spinnerService.hide());
    }

    private BindDriverPages() {
      
        for (var i = 0; i < 14; i++) {
            var nav = <Navigation>{};
            nav.Index = i+1;
            switch (i) {
                case 0:
                    this.BindPage(nav, i, "yourinfo", this.report.IsYourInfoPageValid);
                    break;
                case 1:
                    this.BindPage(nav, i, "prequalificationdriver", this.report.IsPrequalificationPageValid);
                    break;
                case 2:
                    this.BindPage(nav, i, "statement", this.report.IsStatementPageValid);
                    break;
                case 3:
                    this.BindPage(nav, i, "owner", this.report.IsOwnerPageValid);
                    break;
                case 4:
                    this.BindPage(nav, i, "otherdriver", this.report.IsOtherDriverPageValid);
                    break;
                case 5:
                    this.BindPage(nav, i, "witness", this.report.IsWitnessPageValid);
                    break;
                case 6:
                    this.BindPage(nav, i, "involved", this.report.IsInvolvedPageValid);
                    break;
                case 7:
                    this.BindPage(nav, i, "involvedped", this.report.IsInvolvedPageValid);
                    break;
                case 8:
                    this.BindPage(nav, i, "vehicledriverlocation", this.report.IsVehicleDriverLocationPageValid);
                    break;
                case 9:
                    this.BindPage(nav, i, "environment", this.report.IsEnvironmentPageValid);
                    break;
                case 10:
                    this.BindPage(nav, i, "trafficevent", this.report.IsTrafficEventPageValid);
                    break;
                case 11:
                    this.BindPage(nav, i, "email", this.report.IsEmailPageValid);
                    break;
                case 12:
                    this.BindPage(nav, i, "counsellorreview", this.report.IsCouncellorReviewPageValid);
                    break;
                default: break;
            }
        }
    }

    private BindPedCyclistPages() {
        for (var i = 0; i < 12; i++) {
            var nav = <Navigation>{};
            nav.Index = i + 1;
            switch (i) {
                case 0:
                    this.BindPage(nav, i, "yourinfo", this.report.IsYourInfoPageValid);
                    break;
                case 1:
                    this.BindPage(nav, i, "prequalification", this.report.IsPrequalificationPageValid);
                    break;
                case 2:
                    this.BindPage(nav, i, "injury", this.report.IsInjuryPageValid);
                    break;
                case 3:
                    this.BindPage(nav, i, "otherdriver", this.report.IsOtherDriverPageValid);
                    break;
                case 4:
                    this.BindPage(nav, i, "witness", this.report.IsWitnessPageValid);
                    break;
                case 5:
                    this.BindPage(nav, i, "vehicledriverlocation", this.report.IsVehicleDriverLocationPageValid);
                    break;
                case 6:
                    this.BindPage(nav, i, "environment", this.report.IsEnvironmentPageValid);
                    break;
                case 7:
                    this.BindPage(nav, i, "trafficevent", this.report.IsTrafficEventPageValid);
                    break;
                case 9:
                    this.BindPage(nav, i, "statement", this.report.IsStatementPageValid);
                    break;
                case 10:
                    this.BindPage(nav, i, "email", this.report.IsEmailPageValid);
                    break;
                case 11:
                    this.BindPage(nav, i, "counsellorreview", this.report.IsCouncellorReviewPageValid);
                    break;
                default: break;
            }
        }
    }

    private BindPage(nav: Navigation, i: number, page: string, selector: boolean) {
        nav.PageName = page;
        nav.IsValid = selector ? true : false;
        nav.IsCurrentPage = nav.PageName == this.report.CurrentPage ? true : false;
        if (nav.IsCurrentPage)
            this.report.CurrentPageIndex = nav.Index;
        this.report.PageNavigation.push(nav);
    }

    public getInsuranceCompany(search: string): string[] {
      //  this.spinnerService.show();
        var url = this.baseUrl + "api/report/Customer/" + search;
        alert(url);
        this.http
            .get(url)
            .subscribe(res => {
                var v = res as string[];
                return v;
            }, error => console.log(error));
        return [ "Not Found" ];
    }

    onClear(): void {
        if (confirm("Do you really want to clear this report?")) {
            this.initialize();
            location.reload();
        }
    }
}
